import { AdSlot } from './ad-slot';
import { AdSlotConstraintConstraintDto, AdSlotConstraintTypeEnum } from '../dto/recs.dto';

export class AdSlotConstraint {
  private adSlot?: AdSlot;

  private type?: AdSlotConstraintTypeEnum;

  private constraint?: AdSlotConstraintConstraintDto;

  public getAdSlot (): AdSlot | null {
    return this.adSlot ?? null;
  }

  public setAdSlot (adSlot?: AdSlot): this {
    this.adSlot = adSlot;
    return this;
  }

  public getType (): AdSlotConstraintTypeEnum | null {
    return this.type ?? null;
  }

  public getConstraint (): AdSlotConstraintConstraintDto | null {
    return this.constraint ?? null;
  }
}
